import {
  loginConstants,
  surveyQuestionsConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { setItemToStorage } from "../../../../system";
import { customerSurveyService } from "../../services";
import {
  withSpinner,
  success,
  failure,
} from "../../../../redux/actions/utilities";

const {
  SURVEY_DATA,
  GET_CUSTOMER,
  GET_QUESTIONS_ARRAY,
  IS_ALLOWED_TO_VIEW_SURVEY,
  IS_SURVEY_SUBMITTED,
  SURVEY_SUBMITTED,
  GET_THEME_FOR_SURVEY,
  SURVEY_SCREEN_SPINNER,
  GET_BRAND_DETAIL_BY_ID,
} = surveyQuestionsConstants;

//Adding customer survey response
const addSurveyResponse = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, SURVEY_SCREEN_SPINNER, () =>
      customerSurveyService
        .addSurveyResponse(body)
        .then(
          (_response) => {
            dispatch(setIsSurveySubmitted(true));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

const logSurveyInteractionEvent = (body) => {
  return (dispatch) => {
    customerSurveyService.logSurveyInteractionEvent(body).then(
      (_response) => {},
      (error) => {
        customToast(error[0], toastTypes.ERROR);
      }
    );
  };
};

//Function to fetch theme settings
const getThemeByBrandId = (brandId) => {
  return (dispatch) => {
    withSpinner(dispatch, SURVEY_SCREEN_SPINNER, () =>
      customerSurveyService
        .getThemeByBrandId(brandId)
        .then(
          (response) => dispatch(success(response, GET_THEME_FOR_SURVEY)),
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};
//Function to fetch theme settings
const getBrandDetailByBrandId = (brandId) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_BRAND_DETAIL_BY_ID, () =>
      customerSurveyService
        .getBrandDetailByBrandId(brandId)
        .then(
          (response) => dispatch(success(response, GET_BRAND_DETAIL_BY_ID)),
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Function to get customer survey by encrypted params
const getSurveyDataByEncryptedParams = (encryptedParams) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_QUESTIONS_ARRAY, () =>
      customerSurveyService
        .getSurveyDataByEncryptedParams(encryptedParams)
        .then(
          (response) => {
            const {
              customer,
              survey: { brandId, ...surveyQuestions },
              isAllowedToViewSurvey,
              isSurveySubmitted,
            } = response;

            // Dispatch survey permissions and submission status
            dispatch(success(isAllowedToViewSurvey, IS_ALLOWED_TO_VIEW_SURVEY));
            dispatch(success(isSurveySubmitted, SURVEY_SUBMITTED));

            // Store brandId for theme retrieval
            setItemToStorage(loginConstants.BRAND_ID, brandId);

            if (isAllowedToViewSurvey) {
              // Dispatch survey-related data only if access is allowed
              dispatch(success(surveyQuestions, GET_QUESTIONS_ARRAY));
              dispatch(success(customer, GET_CUSTOMER));
              dispatch(success({ brandId, ...surveyQuestions }, SURVEY_DATA));
            }
          },
          (error) => {
            dispatch(failure(error, GET_CUSTOMER));
            dispatch(failure(error, GET_QUESTIONS_ARRAY));
            dispatch(failure(error, SURVEY_DATA));
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

// It will add Customer Event Info when Order Id is zero
const addInvalidOrderInfo = (body) => {
  return () => {
    customerSurveyService.addInvalidOrderInfo(body).then(
      (_response) => {
        // comment
      },
      (error) => {
        customToast(error[0], toastTypes.ERROR);
      }
    );
  };
};

//Handle survey is submitted
const setIsSurveySubmitted = (flag) => (dispatch) => {
  dispatch(success(flag, IS_SURVEY_SUBMITTED));
};

//Exporting for other files
export const customerSurveyActions = {
  addSurveyResponse,
  getThemeByBrandId,
  addInvalidOrderInfo,
  setIsSurveySubmitted,
  getBrandDetailByBrandId,
  getSurveyDataByEncryptedParams,
  logSurveyInteractionEvent,
};
